const PCPX2VW = 100 / 1920;
const MOBILEPX2VW = 100 / 375;
const MEDIAPX2VW = 100 / 1260;

export const px2vw = (num: number, isPc: boolean): string => {
  const ratio = isPc ? PCPX2VW : MOBILEPX2VW;
  return `${num * ratio}vw`;
};

// isMixed - pcValue: 1px 2px 4px;
export const mediaProp = (key: String, pcVal: number|string, mVal: number|string, isMixed: false): string => {
  let finalMediaVal;
  let finalMVal;
  let finalPcVal;

  if (isMixed) { // 混合属性
    finalPcVal = pcVal;
    finalMediaVal = pcVal.split(' ').map(v => `${parseFloat(v) * MEDIAPX2VW}vw`).join(' ');
    finalMVal = mVal.split(' ').map(v => `${parseFloat(v) * MOBILEPX2VW}vw`).join(' ');
  } else {
    finalPcVal = `${pcVal}px`;
    finalMediaVal = `${MEDIAPX2VW * pcVal}vw`;
    finalMVal = `${MOBILEPX2VW * mVal}vw`;
  }
  return `
    ${key}: ${finalPcVal};
    @media (max-width: 1260px) {
      ${key}: ${finalMediaVal};
    }
    @media (max-width: 768px) {
      ${key}: ${finalMVal};
    }
  `;
};

export default {
  px2vw,
  mediaProp,
};
